import React from "react";

import { Grid, GridProps } from "./Grid";
import styles from "./Grid.scss";
import { GridItem } from "./GridItem";

export function PageLayoutWide({ children, ...props }: GridProps) {
  return (
    <Grid outerPadding={true} {...props}>
      <GridItem width={24}>{children}</GridItem>
    </Grid>
  );
}

export function PageLayout({ children, ...props }: GridProps) {
  return (
    <Grid outerPadding={true} {...props}>
      {children}
    </Grid>
  );
}

export function PageLayoutContent({ children, ...props }: GridProps) {
  return (
    <>
      <GridItem md={16} xl={15} {...props}>
        {children}
      </GridItem>
      {/* On large screens, we add an empty column here */}
      <GridItem xs={0} xl={1} />
    </>
  );
}

export function PageLayoutSidebar({ children, ...props }: GridProps) {
  return (
    <GridItem md={8} {...props}>
      {children}
    </GridItem>
  );
}

export function PageLayoutHeader({ children, ...props }: GridProps) {
  return (
    <GridItem className={styles["page-layout-header"]} {...props}>
      {children}
    </GridItem>
  );
}
